import { Injectable } from '@angular/core';
import { HostConfig } from '../models/host-config.model';

@Injectable({ providedIn: 'root' })
export class CasellaConfigService {
  private readonly hostConfig = globalThis.hostConfig;

  get config(): HostConfig {
    return this.hostConfig;
  }
}
